export enum ModalType {
  Settings = "settings",
  Profile = "profile",
  About = "about",
}

export interface ModalContentProps {
  modalType: ModalType;
  onNavigateToProfile: () => void;
  onNavigateToAbout: () => void;
  onBackToSettings: () => void;
  [key: string]: any;
} 